

/**
* 获取URL中的文件名
* @param {string} url 数据源的URL
* @param {boolean} withExtensions 是否返回后缀名，默认为 true
* @returns {string} 解析后的文件名
*/
export function getFileName(url: string, withExtensions?: boolean): string {
  if (withExtensions === undefined) {
    withExtensions = true
  }
  if (!url) {
    return ''
  }
  let result = decodeURIComponent(url).match(/([^/]+?)(?=(\?|$))/)
  if (!result) {
    return ''
  }
  let fileNameWithExtensions = result[1]
  return withExtensions ? fileNameWithExtensions : fileNameWithExtensions.replace(/\.[^.]+$/, '')
}

/**
 * 获取URL中的文件后缀
 * @param {string} url 数据源的URL
 * @returns {string} 解析后的文件后缀
 */
export function getSuffix(url: string): string {
  if (!url) {
    return ''
  }
  let result = decodeURIComponent(url).match(/\.(\w+?)(?=(\?|$))/)
  return result ? result[1] : ''
}

/**
 * 解析URL参数，并进行URL参数解码
 * @param {string} [url] 解析对象
 * @param {string} [key] 需要获取的参数名，不传则返回整个解析的对象
 * @returns {string|object|undefined} 返回整个解决后的对象，或者特定Key的值
 */
export function getParams<T extends Record<string, string | undefined> = Record<string, string | undefined>>(url?: string, key?: string): T[keyof T] | T | undefined {
  // 如果没有提供url，则默认使用当前页面的URL
  if (url === undefined) {
    url = window.location.href
  }

  // 初始化参数对象
  const params: Record<string, string | undefined> = {}

  // 对URL进行解码
  url = decodeURIComponent(url)

  if (url === 'invalid-url') {
    return {} as T
  }

  // 检查是否支持URL和URLSearchParams
  if (typeof URL === 'function' && typeof URLSearchParams === 'function') {
    let searchParams: URLSearchParams

    // 判断是否是查询字符串
    if (/^(\?|$)/.test(url)) {
      // 如果是查询字符串，直接使用URLSearchParams
      searchParams = new URLSearchParams(url)
    } else {
      // 如果是完整的URL，先解析URL，再获取查询参数
      const parsedUrl = new URL(url)
      // eslint-disable-next-line prefer-destructuring
      searchParams = parsedUrl.searchParams
    }

    // 遍历查询参数并添加到params对象中
    searchParams.forEach((value, paramName) => {
      params[paramName] = value
    })
  } else {
    // 如果不支持URL和URLSearchParams，使用正则表达式解析
    url.replace(/[?&](\w+)=([^&?]*)/g, (matchStr: any, paramName: any, value: any) => {
      params[paramName] = value
      return matchStr
    })
  }

  // 如果提供了key，则返回该key对应的值，否则返回整个参数对象
  return key ? (params[key] as T[keyof T]) : (params as T)
}